import { FC, Fragment, useMemo } from 'react';
import { getTerritoryColor } from '../../mapa/mapConstants';
import { hthHelper } from 'src/services';
import { HTHInteractiveMapMapBlockPolygon } from './HTHInteractiveMapMapBlockPolygon';
import { Marker } from '@react-google-maps/api';
import { TerritoryDates } from 'src/custom-hooks/useTerritoryDates';
import { typeHTHTerritory, typeHTHFace } from '@monorepo/models';

type propsType = {
    handleSelectTerritory: (territoryNumber: string) => void;
    selectedTerritories: string[];
    selectionMode: boolean;
    showDates: boolean;
    t: typeHTHTerritory;
    territoryDates: TerritoryDates;
};

export const HTHInteractiveMapMapBlock: FC<propsType> = ({
    handleSelectTerritory, selectedTerritories, selectionMode, showDates, t, territoryDates
}) => {
    const territoryColor = useMemo(() => {
        let tc = getTerritoryColor(t.territoryNumber);
        if (selectionMode) {
            tc = selectedTerritories.includes(t.territoryNumber) ? getTerritoryColor(t.territoryNumber) : '#bdbdbd';
        }
        return tc;
    }, [selectedTerritories, t]);

    const blocks: Map<string, typeHTHFace[]> = useMemo(() => {
        const blocks = new Map<string, typeHTHFace[]>();
        for (const polygon of t.faces) {
            if (!blocks.has(polygon.block)) {
                blocks.set(polygon.block, []);
            }
            blocks.get(polygon.block)!.push(polygon);
        }
        return blocks;
    }, [t.faces]);

    return (
        <>
        {Array.from(blocks.entries()).map(([block, blockPolygons], blockIndex) => {
            const blockCoordinates = hthHelper.GetBlockCoordinates(blockPolygons, block);
            const blockCenter = hthHelper.GetBlockCenter(blockCoordinates);
            if (blockCoordinates.length < 3) {
                return null;
            }
            let fillColor = territoryColor;
            const strokeColor = getTerritoryColor(t.territoryNumber);
            if (selectionMode) {
                fillColor = selectedTerritories.includes(t.territoryNumber) ? territoryColor : '#bdbdbd';
            }
            return (
                <Fragment key={`${t.territoryNumber}-${block}`}>
                    <HTHInteractiveMapMapBlockPolygon
                        color={fillColor}
                        onClick={() => {
                            if (selectionMode) {
                                handleSelectTerritory(t.territoryNumber);
                            } else {
                                // openModalHandler(t.territoryNumber);
                            }
                        }}
                        path={blockCoordinates}
                        strokeColor={strokeColor}
                    />
                    {showDates && blockIndex === 0 && territoryDates[t.territoryNumber] &&
                        <Marker
                            options={{
                                icon: {
                                    url: 'data:image/svg+xml;utf-8,' + encodeURIComponent(`
                                        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="22">
                                            <rect x="0" y="0" width="60" height="22" rx="6" fill="white" stroke="#bbb" stroke-width="1.5"/>
                                        </svg>
                                    `),
                                    anchor: new google.maps.Point(30, 22),
                                    scaledSize: new google.maps.Size(60, 22),
                                },
                                label: {
                                    text: hthHelper.FormatDateForExcel(territoryDates[t.territoryNumber]),
                                    color: '#222',
                                    fontFamily: 'Arial, Helvetica, sans-serif',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    className: 'territory-date-label',
                                },
                                zIndex: 1000,
                            }}
                            position={{
                                lat: blockCenter.lat + 0.00013,
                                lng: blockCenter.lng
                            }}
                        />
                    }
                </Fragment>
            );
        })}
        </>
    );
}
